import App, { Container } from "next/app";
import Head from "next/head";
import React from "react";

import "@olxbr/ds-web/lib/styles.css";
import "@olxbr/olx-components/dist/styles.css";
import "@olxbr/ds-web/lib/styles.css";
import "@olxbr/accounts-core-react-components/lib/esm/index.css";
import "@olxbr/ds-core/dist/olx/tokens.css";
import "@olxbr/ds-core/dist/reset.css";
import "@olxbr/ds-core/dist/styles.css";
import "@olxbr/ds-core/dist/utilities.css";

import { saveRedirectInfo } from "../util/redirect";

export default class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }
    return { pageProps };
  }

  constructor(props) {
    super(props);
    if (process.browser) {
      saveRedirectInfo();
    }
  }

  componentDidCatch(error, errorInfo) {
    super.componentDidCatch(error, errorInfo);
  }

  render() {
    const { Component, pageProps } = this.props;
    return (
      <Container>
        <Head>
          <title>Minha conta | OLX</title>
        </Head>
        <Component {...pageProps} />
      </Container>
    );
  }
}
